import * as Yup from 'yup';
import { RegularExpressions } from '../../../../TCSMApp/global/constants/regular-expressions';
import { getRequiredText } from '../../../../TCSMApp/global/helpers/transformer';
import { EcdMailSettingsProps } from '../../models/epi-model';

export interface MailFormValues {
	name?: string;
	email?: string;		
	message?: string;		
}

export interface MailDestination {
	name: string;
	email: string;	
	itemGuid: string;		
}

export interface MailMessage {
	name: string;
	email: string;
	distinationGuid: string;
	message: string;
	recaptcha: string;	
}

export function MailFormValidationSchema(mailSettings: EcdMailSettingsProps){	
   return Yup.object().shape({			
	name: Yup.string().nullable().required(getRequiredText(mailSettings.requiredFieldErrorTemplate, mailSettings.nameLabel)).matches(RegularExpressions.TwoWordOnlyTextCharacters, mailSettings.nameFormatError),
	email: Yup.string().nullable().required(getRequiredText(mailSettings.requiredFieldErrorTemplate, mailSettings.emailLabel)).email(mailSettings.emailFormatError),
	message: Yup.string().nullable().required(getRequiredText(mailSettings.requiredFieldErrorTemplate, mailSettings.messageLabel)).min(10, mailSettings.messageSizeError)
		.test('check_spaces', (value, context) => {

			if (value?.trim()?.length < 10){
				return context.createError({ message: mailSettings.messageSizeError });
			}

			return true;			
		}),	
   });
}
